module.exports = __webpack_public_path__ + "img/default-avatar.8c11eb43.png";